import { api } from './_init'
import store from '../store'

export const BACKHAUL_ATTRIBUTION_MODELS = {
  ALL_PURCHASES: 'ALL_PURCHASES',
  EVENTS_FROM_PACKAGE: 'EVENTS_FROM_PACKAGE',
  EVENT_SERIES: 'EVENT_SERIES',
}

const getPartnerId = () => store.getState()?.user?.partnerId

// backhaul attribution details for partner_id (settings page)
export const fetchBackhaulAttribution = async () => {
  const partnerId = getPartnerId()

  try {
    const response = await api.get(`/partners/${partnerId}/backhaul_attribution_details`)

    if (response.status === 200) {
      return {
        data: response.data,
        success: true,
        error: false,
      }
    } else {
      return {
        data: response.data,
        success: false,
        error: true,
      }
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: true,
    }
  }
}

export const updateBackhaulAttribution = async (attributionWindow, model) => {
  const partnerId = getPartnerId()

  const payload = {
    backhaul_evaluation_attribution_window: attributionWindow,
    backhaul_evaluation_model: model,
  }

  try { 
    const response = await api.post(`/partners/${partnerId}/backhaul_attribution_details`, payload)

    if (response.status === 200 || response.status === 204) {
      return {
        data: response.data,
        success: true,
        error: false,
      }
    } else {
      return {
        data: response.data,
        success: false,
        error: true,
      }
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: true,
    }
  }
}

// backhaul attribution details for package_id (package builder page)
export const fetchBackhaulAttributionForPackage = async (packageId) => {  
  try {
    const response = await api.get(`/package_builder/packages/${packageId}/backhaul_evaluation_details`)
  
    if (response.status === 200) {
      return {
        data: response.data,
        success: true,
        error: false,
      }
    } else {
      return {
        data: response.data,
        success: false,
        error: true,
      }
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: true,
    }
  }
}
  
export const updateBackhaulAttributionForPackage = async (packageId, data) => {  
  const payload = {
    backhaul_evaluation_attribution_window: data.attributionWindow,
    backhaul_evaluation_model: data.model,
    email_sent_date: data.emailSendDate,
  }
  
  try { 
    const response = await api.put(`/package_builder/packages/${packageId}/backhaul_evaluation_details`, payload)
  
    if (response.status === 200 || response.status === 204) {
      return {
        data: response.data,
        success: true,
        error: false,
      }
    } else {
      return {
        data: response.data,
        success: false,
        error: true,
      }
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: true,
    }
  }
}
